import TableTemplate from "../../TableTemplate/tableTemplate";
import {
  IOptionDomainSearchParam,
  IOptionDomainTableReport,
} from "../../../Interfaces/optionDomain";
import { getOptionDomainTable } from "../../../Requests/optionDomain";
import TableUI from "./TableUI";
import { Additional } from "./Additional";

interface IProps {
  searchParams: IOptionDomainSearchParam;
}

const OptionDomainTable = ({ searchParams }: IProps) => {
  return (
    <TableTemplate<IOptionDomainSearchParam, IOptionDomainTableReport>
      TableUI={({ reports, onAction, sortingType, setSortingType }) => (
        <TableUI
          reports={reports}
          onAction={onAction}
          AdditionalBody={Additional}
          sortingType={sortingType}
          setSortingType={setSortingType}
        />
      )}
      getDataTable={getOptionDomainTable}
      withSort
      searchParameters={searchParams}
    />
  );
};

export default OptionDomainTable;
